export default function processFunnelEchartOption(echartOption) {
  if (!echartOption) {
    return null;
  }

  const [serie] = echartOption.series;

  /**
   * Removemos essa propriedade pois ela é inutil no relatório '-'
   */
  if (serie?.label?.emphasis) {
    delete serie.label.emphasis;
  }

  /**
   * Essa propriedade oculta as labels do gráfico, impossibilitando
   * a visualização da porcentagem
   */
  if (serie?.label?.normal) {
    delete serie.label.normal;
  }

  if (serie?.labelLine) {
    delete serie.labelLine.normal;
    
    serie.labelLine.show = true;
  }

  return { ...echartOption };
}